<form [formGroup]="registerForm" (ngSubmit)="onSubmit($event)">
  <mat-form-field>
    <mat-label>ФИО</mat-label>
    <input matInput formControlName="studentName"
           [required]="true"
           placeholder="Укажите ФИО"
           type="text">
  </mat-form-field>
  <mat-form-field>
    <mat-label>E-mail</mat-label>
    <input matInput formControlName="studentMail"
           [required]="true"
           placeholder="Укажите почту"
           type="text">
  </mat-form-field>
  <div *ngIf="error" class="error">
    {{ error }}
  </div>
  <div class="buttons">
    <button mat-raised-button color="primary" type="submit">Начать тестирование</button>
  </div>
</form>
